import type { Release } from '../types/release'

function getArtistName(release: Release): string | undefined {
  const a = (release as any).artists
  if (typeof a === 'string') return a
  if (Array.isArray(a) && a.length > 0) {
    return a.map((x: any) => x?.name ?? x).filter(Boolean).join(', ')
  }
  return undefined
}

/**
 * Short "Artist — Title" label for display in confirmations / toasts.
 * Returns undefined when neither piece is available.
 */
export function formatReleaseLabel(release: Release): string | undefined {
  const artist = getArtistName(release)
  const title = release.title
  if (artist && title) return `${artist} — ${title}`
  return title || artist || undefined
}
